import React, { useState, useEffect,useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Popup from "../sharedUI/popup";
import ChNwClasses from "./ChangeNwPopUp.module.scss";
import PrimaryButtonLoader from "../sharedUI/button/PrimaryButtonLoader";
import { getSelectedCardtypeNwDetails } from "../../shared/SharedUtility";
import { useAppContent, useErrorCodeVerbiage } from "../../shared/AppContent";
import Image from '../sharedUI/Image/Image';
import {  trackPages, GetAPIErrorMsgForErrorCode, parseHtml } from "../../shared/utility";
import { saveSelectedNwData } from "../../store/actions/UserAction";
import { funcUpdateSSL } from "../../store/actions/SslActions";
import bottomImage from '../../assets/images/pan.png';
import { funcHandleGenericError} from "../../store/actions/AppStateActions";
import { useNavigate } from "react-router-dom";
import {  getPartnerName, isPartnersWithCustomTheme } from "../../shared/PartnerUtility";
const ChangeNwPopUp = (props) => {
  const { errorCodeContent } = useErrorCodeVerbiage();
  const currentAppState = useSelector((state) => state.AppState);
  const navigate = useNavigate();
  const userDetail = useSelector((state) => state.User.UserDetail);
  //const nwMasterData = useSelector(state => state.CardDetails?.nwList);
  //const networkDetails = getNetworkDetails("cardType",userDetail.cardType,nwMasterData);
  const partner = getPartnerName();
  const benefitListPoints = {
    tataneu:   ChNwClasses.benefitListSectionTataNeu,
    yono:     ChNwClasses.benefitListSectionYono,
    default: ChNwClasses.benefitListSection
  };
  const benefitListPointsWeb = {
    yono: ChNwClasses.benefitListSectionYono,
    default: ChNwClasses.benefitListSection
  };
  const themebenefitListPoints = partner && isPartnersWithCustomTheme(partner) ? benefitListPoints[partner] : benefitListPoints.default;
  const themebenefitListPointsWeb = partner && isPartnersWithCustomTheme(partner) ? benefitListPointsWeb[partner] : benefitListPointsWeb.default;
  const { leftSectionContent } = useAppContent();
  const cardListDetails = useSelector(state => state.AppState?.cardListDetails ? state.AppState.cardListDetails : null);
  const imageUrl = useSelector((state) =>
    state.AppState?.cardListDetails?.frontImage
      ? state.AppState.cardListDetails.frontImage
      : state.AppState.cardListDetails.image
  );
  const dispatch = useDispatch();
  const nwData = props.nwData.sort((a, b) => parseFloat(a.priority) - parseFloat(b.priority));
  const funcHandleError = (isGenericError, handleClick, exitEvent, errorMessage) =>
  dispatch(funcHandleGenericError(isGenericError, handleClick, exitEvent, errorMessage));
  //const { applicationSubmissionContent, cardActivatedContent } = useAppContent();
  const downsellCardPopBnfitImg = props.downsellCardPopBenifitImage;
  const selectedDownSellCard =  props.selectedDownSellCard;
  const valError = useSelector((state) => state.User.valError);
  const dumpData = useSelector((state) => state.DumpData.dumpData); 
  const selectedCardType = selectedDownSellCard ? selectedDownSellCard : (userDetail?.shortCode && userDetail?.cardType) ? userDetail?.cardType : dumpData?.cardType!=="" ? dumpData.cardType : cardListDetails?.cardType;
  const selectedProduct = getSelectedCardtypeNwDetails(nwData, selectedCardType);
  const [selectedCardPriority, setSelectedCardPriority] = useState(userDetail?.isNwChanged ==="Y" ? userDetail.priority : selectedProduct.priority);
  const [topPriorityNWData, setTopPriorityNWData] = useState(nwData.filter(card => card.priority <= window.global.config?.TOP_PRIORITY_NW));
  const currentCardType = useRef("");
  const priority = useRef(0);
  const currentNwType = useRef("");
  useEffect( () => {
   /// const selectedCardType = (userDetail?.shortCode || downsellCardPopBnfitImg) ? userDetail?.cardType : cardListDetails?.cardType;
   // const selectedProduct = getSelectedCardtypeNwDetails(nwData, selectedCardType);
    //if(selectedProduct?.priority) 
   // setSelectedCardPriority(userDetail?.network ? userDetail.priority : selectedProduct.priority) ;
    if(downsellCardPopBnfitImg)
    trackPages("tracking_149");
    else
    trackPages("tracking_147");
    if (topPriorityNWData.map((i) => i.cardType).indexOf(selectedCardType) === -1)
      setTopPriorityNWData([...topPriorityNWData, selectedProduct]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])
 
    useEffect(() => {
      if (currentAppState.currentAction==="NwUpdFail" && valError?.errorCode?.length) {
        funcHandleError(
          true,
          changeNwSelected,
          () => navigate("/maintainance"),
          GetAPIErrorMsgForErrorCode("newcard_lead_update", "999", errorCodeContent)
          // 'We could not validate the information you have provided. Please try again'
        );
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [valError]);  

  const funcHandleRadioSelect = (add) => {
    setSelectedCardPriority(add.priority);
    currentCardType.current =  add.cardType;
    currentNwType.current = add.network;
    priority.current = add.priority;
  };
  const changeNwSelected = () => {
    let isNwChanged = "N";
    if( !downsellCardPopBnfitImg && userDetail.shortCode  && currentNwType.current!=="" ) {
      //send data in new-card-lead-update 
      let user = { ...userDetail, cardType:currentCardType.current,
        currentNwType:currentNwType.current,
        priority:priority.current,
        productType: cardListDetails?.productType,
       };
        dispatch(funcUpdateSSL( user, "ChangeNetwork"));   
    }
    else
    {
      if(currentNwType.current && currentCardType.current) {
        let networkDetails = getSelectedCardtypeNwDetails(nwData,currentCardType.current);
        isNwChanged = "Y";
        let user = { ...userDetail,
       //  cardType:currentCardType.current,
         selCurrCardType: currentCardType.current,
         currentNwType:currentNwType.current,
         priority: networkDetails?.priority,
         productType: networkDetails?.productType,
         isNwChanged:isNwChanged   
        }
       //save data in redux
       dispatch(saveSelectedNwData(user));
      }
      if(downsellCardPopBnfitImg)
        trackPages("tracking_150");
        else
        trackPages("tracking_148");
       props.handleChangeNwClose();
    }
  }

  return (
    <Popup
    isCustom={true}
    PopupBox={ChNwClasses.PopupBox}
    Box={`${ChNwClasses.Box} ${downsellCardPopBnfitImg ? ChNwClasses.NwselBoxDownsell : ChNwClasses.NwselBoxSD1}`}
    personalDetailsBody={ChNwClasses.personalDetailsBody}
    CloseBtn={ChNwClasses.CloseBtnPopUp}
      content={
        <>
          <div className={ChNwClasses.benefitHeader}>
            <span>{leftSectionContent?.changeCard_container?.changeNetworkText}</span>
            <span className={ChNwClasses.CloseIcon} onClick={props.handleChangeNwClose}>
              <Image filename={"close_black_-1"} ext={"png"} renditions={["2x"]} />
            </span>
          </div>
          <div className={ChNwClasses.benefitContentContainer}>
            <div className={ChNwClasses.benefitContent}>
              <div className={ChNwClasses.imgSection}>
              <img 
                  src={`${window.location.origin}${downsellCardPopBnfitImg?.image ? downsellCardPopBnfitImg.image : imageUrl}`}
                  className={ChNwClasses.frontImage}
                  alt=""
                />
                <img
                  src={bottomImage}
                  className={ChNwClasses.bottomImage}
                  alt=""
                />
              </div>
              <div className={`${ChNwClasses.benefitListSection} ${themebenefitListPoints} ${themebenefitListPointsWeb}`}>
                <h3 className={ChNwClasses.cardName}>{downsellCardPopBnfitImg?.cardName ? downsellCardPopBnfitImg.cardName : cardListDetails?.name ? cardListDetails.name : "Air India SBI Platinum Card"}</h3>
                {downsellCardPopBnfitImg?.eapplyBenefits ?  parseHtml(downsellCardPopBnfitImg.eapplyBenefits)  : cardListDetails?.eapplyBenefits ? parseHtml(cardListDetails.eapplyBenefits) : ""}

              </div>

            </div>
           <div className={ChNwClasses.productType}>
            {
              <div className={ChNwClasses.radioCont}>
                {topPriorityNWData.map((add, i) => (
                  <div className={ChNwClasses.InputAddManual} key={`"div" ${i}`}>
                    <div className={ChNwClasses.InputRadioF}>
                      <label className={ChNwClasses.radioContainer}>
                        <input
                          key={`"addr"${i}`}    
                          type="radio"
                          value={add.cardType}
                          name="network"
                          onChange={(e) => funcHandleRadioSelect(add)}
                          checked={parseInt(add.priority) === parseInt(selectedCardPriority)}
                        />
                        <span className={ChNwClasses.checkmark}></span>
                      </label>
                      <span className={ChNwClasses.InputTextCSS} key={`"span"${i}`}>
                        {add.network} 
                      </span>
                    </div>

                  </div>
                ))}</div>
            }
              
           </div>
            {
              <PrimaryButtonLoader
                label={leftSectionContent?.changeCard_container?.changeNWContButton}
                filename={"arrow_forward_black_24dp"}
                renditions={["2x"]}
                ext={"png"}
                handleClick={changeNwSelected}
                className={`${ChNwClasses.proceedPrimary} ${ChNwClasses.proceedPrimaryBTN}`}
                appState={currentAppState}
              />} 
          </div>
          
        </>
      }
      handleClose={props.handleChangeNwClose}
      closePrimaryButton={
        ChNwClasses.closePrimaryButton
      }
    />
  );
};
export default ChangeNwPopUp;
